export const nspkCroppedLogo = (
    <svg viewBox="429 255 43.707 282.52" xmlns="http://www.w3.org/2000/svg" height="793.707" width="1122.52">
        <defs>
            <clipPath id="a" clipPathUnits="userSpaceOnUse">
                <path d="M0 595.28h841.89V0H0z" />
            </clipPath>
        </defs>
        <g clipPath="url(#a)" transform="matrix(1.33333 0 0 -1.33333 0 793.707)">
            <path d="M278.585 342.788l19.433-34.618v-21.107l-19.401-34.55z" fill="#5454ae" />
            <path d="M353.178 320.769l18.202 11.122 37.246.028-55.448-33.866z" fill="#dd1059" />
            <path d="M353.077 342.988l.101-45.824-19.472 11.923v68.51z" fill="#f9ad1c" />
            <path d="M408.625 331.919l-37.246-.028-18.302 11.097-19.37 34.61z" fill="#f36228" />
            <path d="M353.178 252.318v22.237l-19.47 11.698.004-68.57z" fill="#58c034" />
            <path d="M371.334 263.339l-73.316 44.83-19.433 34.619 129.966-79.406z" fill="#3e88d0" />
            <path d="M333.711 217.683l19.466 34.636 18.157 11.02 37.217.043z" fill="#27843b" />
            <path d="M278.617 252.513l55.243 33.74-18.577 11.36-17.265-10.55z" fill="#8d3ca2" />
        </g>
    </svg>
);
